import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autofocus"
export default class AutofocusController extends Controller {
  static targets = ["input"]

  inputTargetConnected() {
    setTimeout(() => {
      const input = this.inputTarget

      input.focus()

      // Move caret to the end
      const length = input.value.length
      input.setSelectionRange(length, length)
    }, 100)
  }
}
